import styled from 'styled-components';

import { IOptionContainer } from './types';

const OptionContainer = styled.div<IOptionContainer>`
  background-color: ${Styles.color.white};
  border: 0;
  border-bottom: 1px solid ${Styles.color.grey.five};
  color: ${p => (p.disabled ? Styles.color.grey.three : Styles.color.black)};
  font-size: 0.9375rem;
  font-family: ${Styles.fontFamily.base};
  justify-content: center;
  line-height: 1.75rem;
  margin: 0 0;
  outline: ${Styles.color.tertiary};

  ${({ highlightOnHover }) =>
    highlightOnHover
      ? `
    &:not([disabled]):hover {
      cursor: pointer;
      transition: background-color 0.3s;
      background-color: ${Styles.color.grey.five};
    }
  `
      : ''}
`;

export default OptionContainer;
